var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.095,
    height: 66.416,
    viewBox: "0 0 47.095 66.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path_1067",
    "data-name": "Path 1067",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2674.89 90.361a20.547 20.547 0 1 0-22.555 20.447v9.535h-9.435v4.016h9.436v5.87h4.016v-5.87h9.435v-4.016h-9.435v-9.535a20.574 20.574 0 0 0 18.538-20.447zm-37.529 0a16.981 16.981 0 1 1 16.981 16.981 16.981 16.981 0 0 1-16.981-16.981z",
    style: {
      stroke: "none"
    },
    transform: "translate(-2630.796 -66.813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2654.343 69.813c-11.33 0-20.547 9.218-20.547 20.548 0 10.652 8.149 19.435 18.54 20.447v9.535h-9.436v4.016h9.435v5.87h4.016v-5.87h9.436v-4.016h-9.436v-9.535c10.39-1.012 18.54-9.795 18.54-20.447 0-11.33-9.218-20.548-20.548-20.548m0 37.53c-9.379 0-16.982-7.604-16.982-16.982 0-9.379 7.603-16.981 16.982-16.981 9.378 0 16.981 7.602 16.981 16.98 0 9.38-7.603 16.982-16.981 16.982m0-40.529c12.984 0 23.547 10.564 23.547 23.548 0 5.88-2.186 11.512-6.157 15.861-3.32 3.636-7.643 6.117-12.382 7.147v3.974h6.436c1.656 0 3 1.343 3 3v4.016c0 1.657-1.344 3-3 3h-6.436v2.87c0 1.656-1.343 3-3 3h-4.016c-1.657 0-3-1.344-3-3v-2.87h-6.435c-1.657 0-3-1.343-3-3v-4.016c0-1.657 1.343-3 3-3h6.435v-3.974c-4.738-1.03-9.062-3.51-12.381-7.147-3.971-4.349-6.158-9.982-6.158-15.861 0-12.984 10.563-23.548 23.547-23.548zm0 37.53c3.734 0 7.245-1.455 9.886-4.096 2.64-2.64 4.095-6.152 4.095-9.886 0-3.735-1.454-7.246-4.095-9.887-2.64-2.64-6.152-4.094-9.886-4.094-3.735 0-7.246 1.454-9.887 4.095-2.64 2.64-4.095 6.151-4.095 9.886 0 3.734 1.455 7.245 4.095 9.886 2.641 2.64 6.152 4.095 9.887 4.095z",
    style: {
      fill: "#e86e6e",
      stroke: "none"
    },
    transform: "translate(-2630.796 -66.813)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/female-icon.44e750cd.svg";
export { ForwardRef as ReactComponent };